import assistantEpic from 'modules/assistant/epic'
import assistantReducer from 'modules/assistant/reducer'
import botSettings from 'modules/botSettings/reducer'
import embedEpic from 'modules/embed/epic'
import inboxes from 'modules/inboxes/reducers'
import integrationsEpic from 'modules/integrations/epic'
import integrations from 'modules/integrations/reducers'
import localWorkspaces from 'modules/localWorkspaces/reducers'
import multiEmbedEpic from 'modules/multiEmbed/epic'
import multiEmbed from 'modules/multiEmbed/reducers'
import profileEpic from 'modules/profile/epic'
import profileReducer from 'modules/profile/reducer'
import releaseChannel from 'modules/releaseChannel/reducer'
import routingEpic from 'modules/routing/epics'
import routing from 'modules/routing/reducer'
import teams from 'modules/teams/reducers'
import userProperties from 'modules/user/userPropertiesReducer'

export const rootReducer = [
  {
    key: 'routing',
    reducer: routing,
  },
  {
    key: 'integrations',
    reducer: integrations,
  },
  {
    key: 'releaseChannel',
    reducer: releaseChannel,
  },
  {
    key: 'botSettings',
    reducer: botSettings,
  },
  {
    key: 'multiEmbed',
    reducer: multiEmbed,
  },
  {
    key: 'localWorkspaces',
    reducer: localWorkspaces,
  },
  {
    key: 'userProperties',
    reducer: userProperties,
  },
  {
    key: 'assistant',
    reducer: assistantReducer,
  },
  {
    key: 'profile',
    reducer: profileReducer,
  },
  {
    key: 'teams',
    reducer: teams,
  },
  {
    key: 'inboxes',
    reducer: inboxes,
  },
]

export const rootEpic = [
  profileEpic,
  assistantEpic,
  routingEpic,
  integrationsEpic,
  embedEpic,
  multiEmbedEpic,
]
